<template>
  <div class="choice-box">
    <div class="content">
      <div class="title">Smart Choice, Smarter Child</div>
      <div :class="this.$store.state.isMobile ? 'choice-smallTitle': 'smallTitle'">
        <span>The First Step to Higher Education</span>
      </div>
      <el-row :span="24" class="choice-ul">
        <el-col
          :xs="24"
          :sm="8"
          :md="8"
          :lg="8"
          :xl="8"
          class="chioce-item course"
          @click.native="course()"
        >
          <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/home_img6.jpg" alt="">
          <div class="english">CURRICULUM</div>
          <div class="chinese">课程</div>
          <div class="sketch">
            <p>与美国160家幼儿园同步;</p>
            <p>专业核心课程+特色主题课程</p>
          </div>
        </el-col>
        <el-col
          :xs="24"
          :sm="8"
          :md="8"
          :lg="8"
          :xl="8"
          class="chioce-item"
          @click.native="teacher()"
        >
          <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/home_img5.jpg" alt="">
          <div class="english">STAFF</div>
          <div class="chinese">老师</div>
          <div class="sketch">
            <p>专业资质认证;国内外名校毕业;</p>
            <p>经过严格培训上岗</p>
          </div>
        </el-col>
        <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8" class="chioce-item" @click.native="qa()">
          <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/home_img4.jpg" alt="">
          <div class="english">QA</div>
          <div class="chinese">品质管理</div>
          <div class="sketch">
            <p>12个方向, 28个类别,</p>
            <p>300多项标准</p>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    course() {
      console.log('课程')
      //跳转到课程页面
      this.$uweb.trackEvent("首页choice_课程", "点击");
      this.$router.push({ name: "course" });
    },
    qa() {
      //跳转到qa页面
      this.$uweb.trackEvent("首页choice_qa", "点击");
      this.$router.push({ name: "qa" });
    },
    teacher() {
      //跳转到老师页面
      this.$uweb.trackEvent("首页choice_老师", "点击");
      this.$router.push({ name: "teacher" });
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
.choice-box {
  width: 100%;
  background: url("https://krk-website.oss-cn-beijing.aliyuncs.com/img/home_bg1.jpg")
    no-repeat;
  background-size: cover;
  overflow: hidden;
  .title {
    font-size: 42px;
    font-family: TimesNewRoman;
    font-style: italic;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    margin-top: 100px;
  }
  .choice-ul {
    width: 1230px;
    margin-left: -30px;
    margin-top: 30px;
    margin-bottom: 100px;
    float: left;
    overflow: hidden;
    .chioce-item {
      float: left;
      background: rgba(0, 52, 120, 1);
      overflow: hidden;
      width: 380px;
      margin-left: 30px;
      cursor: pointer;
      img {
        display: block;
        width: 310px;
        height: 185px;
        margin: 30px auto;
      }
      .english {
        position: relative;
        text-align: center;
        font-size: 30px;
        font-family: TimesNewRomanPSMT;
        color: rgba(255, 255, 255, 1);
        margin-bottom: 25px;
      }
      .english::after {
        content: "";
        position: absolute;
        bottom: -10px;
        left: 50%;
        margin-left: -20px;
        width: 40px;
        height: 2px;
        background: rgba(174, 149, 79, 1);
      }
      .chinese {
        text-align: center;
        font-size: 24px;
        color: rgba(255, 255, 255, 1);
      }
      .sketch {
        width: 100%;
        margin: 20px 0 30px;
        text-align: center;
        p {
          text-align: center;
          line-height: 20px;
          font-size: 14px;
          color: #ffffff;
          margin-bottom: 5px;
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .choice-box {
    .title {
      font-size: 25px;
      line-height:35px;
      font-family:TimesNewRomanPS-ItalicMT;
      font-weight:normal;
      color: rgba(255, 255, 255, 1);
      margin-top: 44px;
    }
   .choice-smallTitle {
      padding-top: 13px;
      padding-bottom: 35px;
      text-align: center;
      span{
        display: inline-block;
         height: 20px;
         line-height: 20px;
         text-align: center;
         padding: 0 9px;
         background:rgba(186,154,64,1);
         font-style: italic;
         color:rgba(255,255,255,1);
         font-size:9px;
          font-family:TimesNewRomanPS-BoldItalicMT;
          font-weight:normal;
      }
    }
    .choice-ul {
      width: 100%;
      margin: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 26px;
      .chioce-item {
        width: 61%;
        margin-bottom: 33px;
        padding: 17px;
        box-sizing: border-box;
        background:rgba(0,52,120,1);
        margin-left: 0;
        img {
          display: block;
          width: 100%;
          height: auto;
          margin-bottom: 17px;
        }
        .english {
          position: relative;
          text-align: center;
          font-size:21px;
          font-family:TimesNewRomanPSMT;
          font-weight:400;
          color: rgba(255, 255, 255, 1);
          margin-bottom: 19px;
        }
        .english::after {
          content: "";
          position: absolute;
          bottom: -10px;
          left: 54%;
          margin-left: -20px;
          width: 26px;
          height: 2px;
          background: rgba(174, 149, 79, 1);
        }
        .chinese {
          text-align: center;
          font-size: 18px;
          color: rgba(255, 255, 255, 1);
        }
        .sketch {
          width: 100%;
          margin: 15px 0 0;
          p {
            -webkit-text-size-adjust:none;
            font-size:10px;
            font-family:SourceHanSansCN-Regular;
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:18px;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/index/choice.vue